/**
 * Os ícones do protótipo, como sprite SVG.
 *
 * Transcritos de `Docs/arena-alpha-prototipo.html`. São traços, não
 * preenchimentos: `stroke-width: 1.7` e `currentColor`, definidos uma
 * vez em `svg.ic` no CSS base. É isso que faz o ícone herdar a cor de
 * quem o contém, sem uma prop de cor em lugar nenhum.
 *
 * Sprite em vez de um componente por ícone porque o `<use href="#i-x">`
 * é o que o protótipo faz, e porque os ícones viram elementos de um
 * arquivo só, referenciados quantas vezes for preciso. (`sair`, `sol` e
 * `lua` são do Sand Sports: o protótipo não tinha saída nem tema.)
 */

export const ICONES = [
  'dash',
  'cal',
  'users',
  'money',
  'chart',
  'box',
  'tag',
  'lock',
  'search',
  'bell',
  'plus',
  'up',
  'down',
  'ball',
  'x',
  'info',
  'globe',
  'check',
  'go',
  'swap',
  'wa',
  'clip',
  'sair',
  'sol',
  'lua',
] as const;

export type NomeDeIcone = (typeof ICONES)[number];

/** Injetado uma vez, no topo da árvore. */
export function SpriteDeIcones() {
  return (
    <svg style={{ display: 'none' }} aria-hidden="true">
      <symbol id="i-dash" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="9" rx="2" />
        <rect x="14" y="3" width="7" height="5" rx="2" />
        <rect x="14" y="12" width="7" height="9" rx="2" />
        <rect x="3" y="16" width="7" height="5" rx="2" />
      </symbol>
      <symbol id="i-cal" viewBox="0 0 24 24">
        <rect x="3" y="5" width="18" height="16" rx="3" />
        <path d="M8 3v4M16 3v4M3 10h18" />
      </symbol>
      <symbol id="i-users" viewBox="0 0 24 24">
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3 20c0-3.3 2.7-5.4 6-5.4s6 2.1 6 5.4" />
        <path d="M16 5.6a3.2 3.2 0 0 1 0 6M18 20c0-2.4-.8-4-2-5" />
      </symbol>
      <symbol id="i-money" viewBox="0 0 24 24">
        <rect x="2.5" y="6" width="19" height="12" rx="3" />
        <circle cx="12" cy="12" r="2.6" />
        <path d="M6 12h.01M18 12h.01" />
      </symbol>
      <symbol id="i-chart" viewBox="0 0 24 24">
        <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
      </symbol>
      <symbol id="i-box" viewBox="0 0 24 24">
        <path d="M3 8l9-4 9 4-9 4-9-4z" />
        <path d="M3 8v8l9 4 9-4V8" />
        <path d="M12 12v8" />
      </symbol>
      <symbol id="i-tag" viewBox="0 0 24 24">
        <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" />
        <circle cx="8" cy="8" r="1.4" />
      </symbol>
      <symbol id="i-lock" viewBox="0 0 24 24">
        <rect x="4" y="10" width="16" height="11" rx="3" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
      </symbol>
      <symbol id="i-search" viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.2-3.2" />
      </symbol>
      <symbol id="i-bell" viewBox="0 0 24 24">
        <path d="M18 15V10a6 6 0 1 0-12 0v5l-2 3h16l-2-3z" />
        <path d="M10 21h4" />
      </symbol>
      <symbol id="i-plus" viewBox="0 0 24 24">
        <path d="M12 5v14M5 12h14" />
      </symbol>
      <symbol id="i-up" viewBox="0 0 24 24">
        <path d="M7 17 17 7M9 7h8v8" />
      </symbol>
      <symbol id="i-down" viewBox="0 0 24 24">
        <path d="M7 7l10 10M17 9v8H9" />
      </symbol>
      <symbol id="i-ball" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3c3 3.4 3 14.6 0 18M3.6 9h16.8M3.6 15h16.8" />
      </symbol>
      <symbol id="i-x" viewBox="0 0 24 24">
        <path d="M6 6l12 12M18 6 6 18" />
      </symbol>
      <symbol id="i-info" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
      </symbol>
      <symbol id="i-globe" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.5 2.8 2.5 15.2 0 18M12 3c-2.5 2.8-2.5 15.2 0 18" />
      </symbol>
      <symbol id="i-check" viewBox="0 0 24 24">
        <path d="m5 13 4 4 10-10" />
      </symbol>
      <symbol id="i-go" viewBox="0 0 24 24">
        <path d="m9 6 6 6-6 6" />
      </symbol>
      <symbol id="i-swap" viewBox="0 0 24 24">
        <path d="M7 8h13l-3-3M17 16H4l3 3" />
      </symbol>
      <symbol id="i-wa" viewBox="0 0 24 24">
        <path d="M4 20l1.4-4A8 8 0 1 1 9 19.4L4 20z" />
        <path d="M9 10c.5 2 2.5 4 4.5 4.5" />
      </symbol>
      <symbol id="i-clip" viewBox="0 0 24 24">
        <path d="M14 7l-5.5 5.5a2.8 2.8 0 0 0 4 4L19 10a4.6 4.6 0 0 0-6.5-6.5L6 10" />
      </symbol>
      <symbol id="i-sair" viewBox="0 0 24 24">
        <path d="M9 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3M16 17l5-5-5-5M21 12H9" />
      </symbol>
      <symbol id="i-sol" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </symbol>
      <symbol id="i-lua" viewBox="0 0 24 24">
        <path d="M20 14.5A8 8 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5z" />
      </symbol>
    </svg>
  );
}

export function Icone({
  nome,
  tamanho,
  ...resto
}: { nome: NomeDeIcone; tamanho?: number } & React.SVGProps<SVGSVGElement>) {
  const estilo = tamanho ? { width: tamanho, height: tamanho } : undefined;
  return (
    <svg className="ic" style={estilo} aria-hidden="true" {...resto}>
      <use href={`#i-${nome}`} />
    </svg>
  );
}
